
import { PositionCategoryModalNames } from "./position.category.modal.name";
import PositionCategoryModalCreate from "../page/components/position.category.create";
import { PositionCategoryControllerState, PositionCategoryControllerAction } from "../controller/position.category.controller";
import PositionCategoryModalUpdate from "../page/components/position.category.update";

export interface PositionCategoryChildrenModel {
    name: PositionCategoryModalNames;
    child: ({ ctrl }: { ctrl: PositionCategoryControllerState & PositionCategoryControllerAction }) => JSX.Element,
}
export const PositionCategoryModalChildrenData: PositionCategoryChildrenModel[] = [
    {
        name: PositionCategoryModalNames.CREATE,
        child: ({ ctrl }: { ctrl: PositionCategoryControllerState & PositionCategoryControllerAction }) => <PositionCategoryModalCreate ctrl={ctrl} />,
    },
    {
        name: PositionCategoryModalNames.UPDATE,
        child: ({ ctrl }: { ctrl: PositionCategoryControllerState & PositionCategoryControllerAction }) => <PositionCategoryModalUpdate ctrl={ctrl} />,
    }
]